export default __webpack_public_path__ + "static/line-presentation_by-9f1677d880494e89ab23e6851fb4ae5c.png";